import {
  onUpdated, watch, nextTick, computed,
} from 'vue';
import analyticsUtil from '@common-vue/site-monetization/src/utils/analyticsUtil';
import { useStore } from 'vuex';
import usePageData from '@composables/usePageData';
import usePageType from './usePageType';

const getFormatLevelBeacons = () => {
  const store = useStore();
  const formatLevelBeacons = store?.getters?.getSortableGrid?.formatLevelBeacons ?? {};
  return formatLevelBeacons;
};

const initInGridSPItemsAnalytics = (itemsRef, sponsoredItemRefs) => {
  let gridItemsUpdated = false;
  const { isSearch } = usePageType();
  const pageData = usePageData();
  const meta = computed(() => pageData?.value?.meta);
  const isPhone = computed(() => meta?.value?.context?.deviceType === 'PHONE');
  const properties = computed(() => meta?.value?.properties);
  let unObserveFn;
  unObserveFn = analyticsUtil.initInGridPromoItemsAnalytics(
    getFormatLevelBeacons(),
    properties.value.enableImpressionTagsForSMProducts,
    properties.value.enableClickTagsForSMProducts,
    isPhone.value,
    isSearch,
    sponsoredItemRefs,
  );
  watch(itemsRef, async () => {
    /* istanbul ignore else */
    if (unObserveFn) {
      unObserveFn();
    }
    await nextTick();
    gridItemsUpdated = true;
  });
  onUpdated(() => {
    /* istanbul ignore next */
    if (gridItemsUpdated) {
      unObserveFn = analyticsUtil.initInGridPromoItemsAnalytics(
        getFormatLevelBeacons(),
        properties.value.enableImpressionTagsForSMProducts,
        properties.value.enableClickTagsForSMProducts,
        isPhone.value,
        isSearch,
        sponsoredItemRefs,
      );
      gridItemsUpdated = false;
    }
  });
};
export default function useInGridSPItemsAnalytics() {
  return {
    initInGridSPItemsAnalytics,
  };
}
